import React, { useState, useRef, useEffect } from 'react';
import FeatureLayer from './FeatureLayer';
import { useUpdateEffect, useDeepCompareEffect } from 'ahooks';
import { registerEventLayer } from '../events';
import useProps from '../_util/useProps';
import Provider from '../_util/Provider';
import { cloneDeep } from 'lodash';

export default function(props) {
    const {
        data,
        features,
        url,
        params,
        afterGetData,
        style,
        markerStyle,
        zIndex,
        id: key,
        _key,
        children,
        renderMode,
        show = true,
        layerControl = true,
        method,
        legend,
        group,
        cluster,
        ...otherProps
    } = props;
    const [layerLoad, setLayerLoad] = useState(false);
    const layerRef = useRef();
    const { map, groupLayer } = useProps();

    useEffect(() => {
        let layer = new FeatureLayer({
            url,
            data,
            afterGetData,
            renderMode,
            features,
            params,
            style,
            markerStyle,
            zIndex,
            key: key || _key,
            show,
            layerControl,
            legend,
            group: group && cloneDeep(group),
            map,
            groupLayer,
            method,
            cluster,
            ...otherProps,
        });

        // 注册事件
        registerEventLayer(layer, props);

        setLayerLoad(true);

        if (groupLayer) {
            groupLayer.addLayer(layer);
        } else {
            map.addLayer(layer);
        }

        layerRef.current = layer;
        return () => {
            if (groupLayer) {
                groupLayer.removeLayer(layer);
            } else {
                map.removeLayer(layer);
            }
        };
    }, []);

    useDeepCompareEffect(() => {
        layerRef.current.style = style;
        layerRef.current.setStyle();
    }, [style]);

    useUpdateEffect(() => {
        layerRef.current.data = data;

        if (layerRef.current.show) {
            layerRef.current.loadData(data);
        } else {
            layerRef.current.inited = false;
        }
    }, [JSON.stringify(data)]);

    useUpdateEffect(() => {
        layerRef.current.setRenderMode(renderMode);
    }, [renderMode]);

    useUpdateEffect(() => {
        layerRef.current.show = show;
    }, [show]);

    useUpdateEffect(() => {
        layerRef.current.template = otherProps.template;
    }, [otherProps.template]);

    useUpdateEffect(() => {
        layerRef.current.setGroup(cloneDeep(group));
    }, [JSON.stringify(group)]);

    useUpdateEffect(() => {
        layerRef.current.url = url;
        layerRef.current.method = method;
        layerRef.current.params = params;

        if (layerRef.current.show) {
            layerRef.current.loadUrlData(url, params, method);
        } else {
            layerRef.current.inited = false;
        }
    }, [url, method, JSON.stringify(params)]);

    useUpdateEffect(() => {
        layerRef.current.cluster = cluster;
    }, [JSON.stringify(cluster)]);

    return (
        <>
            {layerLoad && (
                <Provider
                    value={{
                        map,
                        featureLayer: layerRef.current,
                    }}
                >
                    {children}
                </Provider>
            )}
        </>
    );
}
